    <header class="page-head">
      <div>
        <h1 class="page-title">Orders</h1>
        <p class="page-subtitle">Manage new service and product orders before final checkout.</p>
      </div>
    </header>

    <section class="orders-grid">
      <article class="order-card span-6" *ngFor="let order of orders">
        <div class="order-top">
          <div>
            <h2 class="section-title section-title-tight">{{ order.name }}</h2>
            <p class="label">{{ order.description }}</p>
          </div>
          <span class="status-chip">{{ order.status }}</span>
        </div>
        <div class="btn-row btn-row-spaced-top">
          <a class="btn btn-secondary" routerLink="/services">Adjust order</a>
          <a class="btn btn-primary" routerLink="/checkout">Proceed to checkout</a>
        </div>
      </article>
    </section>
